import type {
  FileDiff,
  Message,
  Part,
  PermissionRequest,
  QuestionRequest,
  SessionStatus,
} from "@mux/sdk/v2/client"

import type { SessionDiffSummary } from "./types"

type SessionCache = {
  session_status: Record<string, SessionStatus | undefined>
  session_diff: Record<string, FileDiff[] | undefined>
  session_diff_summary?: Record<string, SessionDiffSummary | undefined>
  message: Record<string, Message[] | undefined>
  part: Record<string, Part[] | undefined>
  permission: Record<string, PermissionRequest[] | undefined>
  question: Record<string, QuestionRequest[] | undefined>
}

export function dropSessionCaches(store: SessionCache, sessionIDs: Iterable<string>) {
  const stale = new Set(Array.from(sessionIDs).filter(Boolean))
  if (stale.size === 0) return

  // Every part of a message belongs to the message's session, so the first
  // part says whose parts these are, including those of messages not loaded.
  for (const key of Object.keys(store.part)) {
    if (stale.has(store.part[key]?.[0]?.sessionID ?? "")) delete store.part[key]
  }

  for (const sessionID of stale) {
    delete store.message[sessionID]
    delete store.session_diff[sessionID]
    if (store.session_diff_summary) delete store.session_diff_summary[sessionID]
    delete store.permission[sessionID]
    delete store.question[sessionID]
  }
}
